import React from "react";
import PropTypes from "prop-types";
import DefaultAvatar from "../../../../../../assets/images/users/avatar-mobi.png";
import ProfileImageBack from "../../../../../../assets/images/profile-img.png";
import { Row, Col, Card, CardBody, CardTitle, Table } from "reactstrap";
import styled from "styled-components";

const ProfilePage = props => {
  const { setEditProfile, profileData, languages, positions, profile_loading } =
    props;

  const getLanguage = current => {
    let selectedLang = languages.findIndex(i => i.value === current);
    return languages[selectedLang]?.label || 'None';
  };

  const renderPositions = pos => {
    let arr = [];
    pos.map(i => {
      arr.push(i.title);
    });
    return arr.join(", ");
  };

  return (
    <Row className="justify-content-center">
      <Col xl={3}>
        <Card className="overflow-hidden" style={{ height: 314 }}>
          <div className="bg-primary bg-soft">
            <Row className="mb-3">
              <Col xs="7">
                <div className="text-primary p-3"></div>
              </Col>
              <Col xs="3" className="align-self-end">
                <img src={ProfileImageBack} alt="" className="img-fluid" />
              </Col>
            </Row>
          </div>
          <CardBody>
            <Row>
              <Col xl={12} align="center">
                <div className="avatar-xl profile-user-wid mb-3">
                  <img
                    src={
                      profileData?.profile_pic
                        ? profileData.profile.pic
                        : DefaultAvatar
                    }
                    alt=""
                    className="img-thumbnail rounded-circle"
                  />
                </div>
                <h5 className="font-size-15 text-truncate">
                  {profileData?.username || "Not found"}
                </h5>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Col>
      <Col xl={8}>
        <Card className="overflow-hidden">
          <CardBody>
            {profile_loading && (
              <LoaderStyled className="table-loader">
                <div className="spinner-border text-primary m-1" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </LoaderStyled>
            )}
            <Row
              style={{
                userSelect: "none",
                opacity: profile_loading ? "0.5" : "1",
              }}
              className="mt-2"
            >
              <Col md={12}>
                <div
                  className="d-flex"
                  style={{
                    justifyContent: "space-between",
                  }}
                >
                  <div>
                    <CardTitle className="mb-4 h4">
                      Personal Information
                    </CardTitle>
                  </div>
                  <div>
                    {props.permissions["change_usermodel"] && (
                      <EditDataStyled
                        className="bx bx-pencil font-size-18 mw-2 float-end"
                        onClick={() => setEditProfile(true)}
                      />
                    )}
                  </div>
                </div>
              </Col>
            </Row>
            <div
              style={{ opacity: profile_loading ? "0.5" : "1" }}
              className="table-responsive"
            >
              <Table className="table-nowrap mb-0">
                <tbody>
                  <tr>
                    <th scope="row">Full Name :</th>
                    <td>
                      {profileData?.first_name || "Not found"}{" "}
                      {profileData?.last_name || "Not found"}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Mobile :</th>
                    <td>{profileData?.phone || "Not found"}</td>
                  </tr>
                  <tr>
                    <th scope="row">E-mail :</th>
                    <td>{profileData?.email || "Not found"}</td>
                  </tr>
                  <tr>
                    <th scope="row">Positions :</th>
                    <td>
                      {profileData?.positions.length > 0
                        ? renderPositions(profileData.positions)
                        : "Not found"}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Lang :</th>
                    <td>
                      {profileData?.lang
                        ? getLanguage(profileData.lang)
                        : "Not found"}
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </CardBody>
        </Card>
        {/* )} */}
      </Col>
    </Row>
  );
};

const LoaderStyled = styled.div`
  opacity: 1;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const EditDataStyled = styled.i`
  cursor: pointer;
  transition-duration: 0.5s;
  &:hover {
    color: #2684ff;
    transition-duration: 0.5s;
  }
`;

ProfilePage.propTypes = {
  positions: PropTypes.any,
  languages: PropTypes.array,
  setEditProfile: PropTypes.func,
  profileData: PropTypes.any,
  profile_loading: PropTypes.bool,
  permissions: PropTypes.any,
};

export default ProfilePage;
